/**
 * globals.js — bridge React/ReactDOM onto window.
 *
 * The UI modules were authored as classic global-scope scripts (they reference
 * `React`, `ReactDOM`, and each other via window globals, resolving names at
 * render time). To run them under Vite/ESM without a full rewrite, we expose the
 * React onto the global object BEFORE any UI module evaluates.
 *
 * main.jsx imports this first, so window.React exists in time for modules that
 * touch React at import-time (e.g. i18n.jsx's React.createContext).
 */
import React from "react";
import * as ReactDOMClient from "react-dom/client";

window.React = React;
window.ReactDOM = ReactDOMClient; // provides createRoot(), used by app.jsx
